// extracted by mini-css-extract-plugin
export default {"anchor":"IconButtonSelector-module__anchor__oRPQC_J"};